"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ExtendedArray_1 = __importDefault(require("../tools/ExtendedArray"));
var types_1 = require("../data/types");
var weapon_1 = __importDefault(require("./weapon"));
var armor_1 = __importDefault(require("./armor"));
var Items = /** @class */ (function (_super) {
    __extends(Items, _super);
    function Items() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.disentchant = function (itemId) {
            var item = _this.findById(itemId);
            var name = item.getName();
            var resources = item.disentchant();
            _this.removeItem(item);
            return {
                name: name,
                resources: resources
            };
        };
        return _this;
    }
    Items.hydrate = function (obj) {
        var items = Object.assign(new Items(), obj);
        for (var itemIndex in obj) {
            var item = obj[itemIndex];
            var ti = void 0;
            switch (item.category) {
                case types_1.ItemCategories.Weapon:
                    ti = weapon_1.default.hydrate(item);
                    break;
                case types_1.ItemCategories.Armor:
                    ti = armor_1.default.hydrate(item);
                    break;
                default:
                    break;
            }
            items[itemIndex] = ti;
        }
        return items;
    };
    return Items;
}(ExtendedArray_1.default));
exports.default = Items;
